import { useDeviceType } from '@calendly/ui/hooks/use-device-type';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { Layout } from 'components/layout';
import { MemberContent } from './member_content';
import { SidePanel } from '../../../../../../components/side_panel';
import { AvailableMemberHours } from '../../available_member_hours';
const bodyIsPhoneCss = "bugyerh";
const bodyCss = "b1ixygg4";
const Body = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  const isPhone = useDeviceType('isPhone');
  return <Component ref={ref} {...restProps} className={classNames(bodyCss, {
    [bodyIsPhoneCss]: isPhone
  }, props.className)} />;
});
export const AvailabilityListSidePanel = ({
  formPath,
  onClose,
  targetRef
}) => <SidePanel targetRef={targetRef} onClose={onClose} header={<MemberContent formPath={formPath} />}>
    <Body>
      <Layout direction="column" padding="16" paddingRight="8" grow>
        <AvailableMemberHours formPath={formPath} isMultiHost />
      </Layout>
    </Body>
  </SidePanel>;

require("./availability_list_side_panel.wyw-in-js.css!=!../../../../../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./availability_list_side_panel.js");